























































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Commande} from '@/models';

import CrudCommandeFilter from '@/components/Crud/Commande/Filter.vue';
import CrudCommandeEditDialog from '@/components/Crud/Commande/EditDialog.vue';
import CrudCommandeListHistorique from '@/components/Crud/Commande/ListHistorique.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import {CommandeFilter, storeCommandeHistorique} from '@/stores/modules/commande';

@Component({
	components: {
		CrudCommandeFilter,
		CrudCommandeEditDialog,
		CrudCommandeListHistorique,
		CrudDeleteDialog,
	}
})
export default class CommandeListView extends Vue {

	@Stored(() => storeCommandeHistorique) private commandes!: ResultType<Commande>;
	@Stored(() => storeCommandeHistorique) private filters!: CommandeFilter;

	private imgPath: string = "";

	private editCommande: Commande = null;
	private deletedCommande: Commande = null;
	private storeCommandeHistorique = storeCommandeHistorique;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editCommande = new Commande();
		this.refresh();
	}

	private refresh(): void {
	}
}
